/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
function e(e){return{enabled:!!e?.length}}export{e as writeNonEmptyCollectionPolicy};
